<template>
  <div class="success-payment">
        <div class="suc-inner">
            <div class="suc-img">
                <img src="../assets/suc.png" alt="缴费成功">
            </div>
            <h3>缴费成功</h3>
            <p>
                物业费订单已提交到{{property_name}}，<br/>
                感谢对我们的支持，祝您生活愉快！
            </p>
            <div class="contact-us">
                <span>物业联系电话</span>
                <a :href="property_tel">{{property_tel_num}}</a>
            </div>
            <div v-if="check_status===0">
                <div class="choose-gift" v-if="fee_activity_gift">
                    <div class="row-radio">
                        <h3>选择缴费礼品</h3>
                        <div class="active-text" v-if="activity_explain"><span>活动说明： {{activity_explain}}</span></div>
                        <div v-for="(item, index) in fee_activity_gift" class="radio-text">
                            <input type="radio" name="gift_id"  @click = "changeGift(item.gift_id,item.name)"><label>{{item.name}}</label>
                        </div>
                    </div>
                    <div class="handle-btns">
                        <button class="sub" @click="subGift()">确定</button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="choose-gift" v-if="fee_activity_gift">
                    <div class="row-radio">
                        <h3>成功选择缴费礼品</h3>
                        <div class="active-text" v-if="activity_explain"><span>活动说明： {{activity_explain}}</span></div>
                        <div class="radio-text">
                            <input type="radio" checked><label>{{gift_name}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
        property_tel:'',
        property_tel_num:'',
        property_name:'',
        fee_activity_gift:'',
        gift_id:0,
        gift_name:'',
        check_status:0,
        activity_explain: ''
    }
  },
  created(){
      this.getPropertyInfo();
  },
  methods:{
        changeGift(gift_id, gift_name){
            this.gift_id = gift_id;
            this.gift_name = gift_name;
        },
        subGift(){
            console.log('提交gift_id=：')
            console.log(this.gift_id)
            console.log(this.gift_name)
            if(this.gift_id == 0){
                this.$toast({
                    message:'请选择缴费礼品',
                    position:'bottom',
                    duration:'2000'
                })
            }else{
                this.$messagebox({
                    message: '确定选择：' + this.gift_name +'?',
                    closeOnClickModal: false,
                    showCancelButton: true,
                    confirmButtonText: '确定'
                }).then(action => {
                    if (action === 'confirm') { // 确认的回调
                        let url = '/jmobile/WxApi/fee_order_gift/order_id/'+this.$route.query.orderId+'/fee_gift_id/'+this.gift_id;
                        this.axios.get(url).then((res)=>{
                            if(res.data.status == '1'){
                                this.check_status = 1;
                                this.$toast({
                                    message:'提交成功',
                                    position:'bottom',
                                    duration:'2000'
                                })
                            }
                        })
                    }
                })
                
            }
        },
        getPropertyInfo(){
            let url = '/jmobile/WxApi/order_get_property_info/order_id/'+this.$route.query.orderId;
            this.axios.get(url).then((res)=>{
                if(res.data.status == '1'){
                    this.property_tel = 'tel:' + res.data.data.property_tel;
                    this.property_tel_num = res.data.data.property_tel;
                    this.property_name = res.data.data.property_name;
                    if(res.data.data.fee_activity_gift.length > 0){
                        this.fee_activity_gift = res.data.data.fee_activity_gift;
                        this.activity_explain = res.data.data.explain;
                    }
                }else{
                    // this.$toast({
                    //     message:res.data.info,
                    //     position:'bottom',
                    //     duration:'2000'
                    // });
                }
            }).catch((response)=>{
                    // this.$toast({
                    //     message:'网络错误',
                    //     position:'bottom',
                    //     duration:'2000'
                    // })
            });
        },
  }
}
</script>
<style lang="less">
.success-payment{
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background: #f2f2f2;
    font-size: 14px;
    color: #999;
    .suc-inner{
        padding-top: 25px;
        background: #fff;
        .suc-img{
            text-align: center;
            img{
                width: 69px;
                height: 69px;
            }
        }
        h3{
            margin: 20px 0;
            text-align: center;
            font-weight: normal;
            font-size: 15px;
            color: #333;
        }
        p{
            margin-bottom: 22px;
            text-align: center;
        }
        .contact-us{
            display: flex;
            justify-content: space-between;
            padding: 0 15px;
            height: 42px;
            line-height: 42px;
            border-top: 1px solid #f2f2f2;
            span{
                &:last-child{
                    color: #ffaf14;
                }
            }
        }
        .choose-gift{
            padding: 20px 0;
        }
        .row-radio {
            border-top: 1px solid #f2f2f2;
            padding: 15px 15px;
        }
        .row-radio h3 {
            margin: 30px 0;
            text-align: center;
            font-weight: bold;
            font-size: 21px;
            color: #333;
        }
        .row-radio .radio-text {
            padding: 8px 50px;
        }
        .active-text{
            margin: 40px 0;
            text-align: center;
        }
        .active-text span {
            height: 25px;
            line-height: 25px;
            font-size: 17px;
            color: red;
        }
        .radio-text{
            font-size: 18px;
        }
        .row-radio input {
            margin-right: 15px;
        }
        .handle-btns{
            margin: 40px 0 20px 0;
            padding: 0 20px;
            color: #000;
            button{
                display: block;
                width: 100%;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 10px;
                font-size: 15px;
                color: #fff;
                &.sub{
                    background: #ffaf1c;
                }
                &.contact{
                    margin: 10px 0 22px;
                    background: #c5c5c5;
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/SuccessPay.vue